import { FEEDBACK_MESSAGES, PREFIX_PHONE_LIST } from '../../config'
import { WEEK_MOMENTS, checkDay, checkHour } from '../deleteOutHoursDRP'
import { addErrorMsg } from './addErrorMsg'
import { buildPhoneCodes } from './buildPhoneCodes'
import { getDayToCall, setTextDependingOnDayFr } from './dynamicValuesToCallDate'
import { validationPhoneWithPrefix } from './validationPhoneWithPrefix'

export function FranVersion() {
  const $form = document.getElementById('custom-budget-form')
  const $modalInFr = document.querySelector('.custom-budget--fr')
  const $explainMsgPhone = document.querySelector('.custom-budget__msg')
  const $phoneInput = $form.querySelector('input[name="telefono"]')

  const TEMPLATES_FOR_DATE_CALL = {
    SET_HOUR: `
      <option selected value="">Choisissez une heure</option>
      <option value="${getDayToCall()} 9 to 13h">Appelez-moi aujourd'hui ${setTextDependingOnDayFr()} de 9h à 13h</option>
      <option value="${getDayToCall()} 13 to 15h">Appelez-moi aujourd'hui ${setTextDependingOnDayFr()} de 13h à 15h</option>
      <option value="${getDayToCall()} 15 to 17h">Appelez-moi aujourd'hui ${setTextDependingOnDayFr()} de 15h à 17h</option>
      <option value="${getDayToCall()} 17 to 20h">Appelez-moi aujourd'hui ${setTextDependingOnDayFr()}  de 17h à 20h</option>
    `
  }

  if ($modalInFr !== null) {
    const $selectToCodes = buildPhoneCodes()
    let PREFIX_SELECTED = PREFIX_PHONE_LIST.FRENCH_PHONE

    $selectToCodes.addEventListener('change', (event) => {
      const inputWrap = $selectToCodes.parentElement
      const getError = inputWrap.querySelector('.custom-budget__error')
      getError?.remove()

      if (event.target.value === 'other') {
        addErrorMsg({
          field: 'telefono',
          msg: FEEDBACK_MESSAGES.HOURS.OFFICE_OFF_FR
        })
        $phoneInput.setAttribute('disabled', 'true')
        return
      }

      if ($phoneInput.value !== '') {
        
        PREFIX_SELECTED = event.target.value
        validationPhoneWithPrefix({
          explainMsgPhone: $explainMsgPhone,
          phoneValue: $phoneInput.value,
          prefixSelected: PREFIX_SELECTED
        })
        $phoneInput.removeAttribute('disabled')
      }
    })

    const callDateSelect = document.getElementById('call_date-select')
    const callDateSelectWrap = document.getElementById('call_date-wrap')
    callDateSelect.innerHTML = TEMPLATES_FOR_DATE_CALL.SET_HOUR

    // if (
    //   checkHour({
    //     start: 0,
    //     end: 20,
    //     customMinutes: 59
    //   }) ||
    //   checkHour({
    //     start: 20,
    //     end: 23,
    //     customMinutes: 59
    //   }) ||
    //   checkDay() === WEEK_MOMENTS.SATURDAY ||
    //   checkDay() === WEEK_MOMENTS.SUNDAY ||
    //   true 
    // ) {
    //   callDateSelect.innerHTML = TEMPLATES_FOR_DATE_CALL.SET_HOUR
    // } else {
    //   callDateSelectWrap?.remove()
    // }
  }
}
